const colors = {
  red: "#D96060",
  orange: "#DB9839",
  yellow: "#D9C660",
  lightYellow: "#F3FFB1",
  green: "#539A1B",
  lightBlue: "#51C1D4",
  blue: "#287CD8",
  darkBlue: "#1046C8",
  purple: "#7551D4",
  darkGrey: "#121724",
  lightGrey: "#6D7DA1",
  medGrey: "#343F57",
  grey: "#1F2533"
}

export const elementColors = {
  sleep: "#516B9D",
  fire: "#FF4805",
  poison: "#8D669D",
  dragon: "#6B72B6",
  thunder: "#F7F606",
  ice: "#A3C5F0",
  water: "#93EBFF",
  paralysis: "#D0BF78",
  blast: "#CC976F"
}

export default colors
